// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3XoQN","left":"styles_left__3Fvuc","block":"styles_block__2EAwK","textarea":"styles_textarea__-XvRN","footer":"styles_footer__1UOuc"};